import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface RespondentCountDTO {
  count: number;
}

export class RespondentCount {
  readonly isRespondentCountRespondentCount: boolean = true;

  readonly count: number;

  static readonly constraints = {
    "count": {
      "minValue": 0,
    }
  }

  constructor(
  count: number
  ) {
    RespondentCount.validateCount(count);
    this.count = count;
  }

  static fromDTO(dto: RespondentCountDTO): RespondentCount {
    const count = getInt32(dto, "count", InvalidRespondentCountCountError);
    return new RespondentCount(
      count
    );
  }

  toDTO(): RespondentCountDTO {
    const dto: RespondentCountDTO = {
        count: this.count
    };
    return dto;
  }
  private static validateCount = (count: number): void => {
    if(count < 0) {
      throw new InvalidRespondentCountCountMinValueError(
        0,
        `Attribute count has value ${count}. Min value is 0.`
      );
    }
  }
  
}

RespondentCount.prototype.toString = function toString(): string {
  return `RespondentCount(count='${this.count}')`;
};

export class InvalidRespondentCountError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentCountError";
  }
}
export class InvalidRespondentCountCountError extends InvalidRespondentCountError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentCountCountError";
  }
}

export class InvalidRespondentCountCountMinValueError extends InvalidRespondentCountCountError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentCountCountMinValueError";
  }
}
